const storage = {
    accountingBridgeScroll: 0,
    maintenanceMode: false,
}

export const StorageController = {
    setKey: (key, value) => {
        storage[key] = value;
    },
    getKey: (key) => {
        if (storage[key] !== undefined) {
            return storage[key];
        } else {
            return null;
        }
    },
}
